module.exports = __webpack_public_path__ + "shopping.svg?43aeed626b6d21627a62fbb7dc10119d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shopping.svg
// module id = 59
// module chunks = 0